/**
 * Tracking exclusion logic.
 * Pure TypeScript — no DOM or React/React Native dependencies.
 *
 * Excludes platform admins, active impersonation sessions, explicit exclusions,
 * and internal administrative routes.
 */

export interface ShouldTrackInput {
  isPlatformAdmin: boolean;
  isImpersonating: boolean;
  isAnalyticsExcluded?: boolean;
  pathname: string;
}

export function shouldTrack(input: ShouldTrackInput): boolean {
  if (input.isPlatformAdmin) return false;
  if (input.isImpersonating) return false;
  if (input.isAnalyticsExcluded) return false;

  const path = input.pathname || '';
  if (path === '/admin' || path.startsWith('/admin/')) {
    return false;
  }

  return true;
}
